import * as React from 'react'
// CComponents & CHelpers
import {H2} from '@frontrow/console/src/components/typography'

import MatchCheckBoxesGroup from '@frontrow/console/src/components/pages/import-sis-ids/sis-matches-display/match-checkboxes-group'
import SisMatchesDataTable from './sis-matches-data-table'
import SisMatchesActions from './sis-matches-actions'

import {type SelectedStudentT} from '@frontrow/console/src/components/pages/import-sis-ids/sis-matches-display'

type Props = {
  matchAllChecked: boolean
  matchNameTeacherChecked: boolean
  matchNameGradeChecked: boolean
  selectedStudents: Array<SelectedStudentT>
  selectStudentRow: (original: SelectedStudentT) => React.ReactElement
  districtStudentMatchAccessor: (original: SelectedStudentT) => React.ReactElement
  onChangeAllMatchCheckbox: (event: React.ChangeEvent<HTMLInputElement>) => void
  onChangeNameTeacherCheckbox: (event: React.ChangeEvent<HTMLInputElement>) => void
  onChangeNameGradeCheckbox: (event: React.ChangeEvent<HTMLInputElement>) => void
  onMatchSelectedStudents: () => void
}

export default function SisMatchesDisplay(props: Props): React.ReactElement {
  const {
    matchAllChecked,
    matchNameTeacherChecked,
    matchNameGradeChecked,
    selectedStudents,
    selectStudentRow,
    districtStudentMatchAccessor,
    onChangeAllMatchCheckbox,
    onChangeNameTeacherCheckbox,
    onChangeNameGradeCheckbox,
    onMatchSelectedStudents
  } = props

  return selectedStudents !== null && selectedStudents !== undefined ? (
    <React.Fragment>
      <H2>Select the matches that you want to accept:</H2>
      <br />
      <MatchCheckBoxesGroup
        matchAllChecked={matchAllChecked}
        matchNameTeacherChecked={matchNameTeacherChecked}
        matchNameGradeChecked={matchNameGradeChecked}
        onChangeAllMatchCheckbox={onChangeAllMatchCheckbox}
        onChangeNameTeacherCheckbox={onChangeNameTeacherCheckbox}
        onChangeNameGradeCheckbox={onChangeNameGradeCheckbox}
      />
      <SisMatchesDataTable
        selectedStudents={selectedStudents}
        selectStudentRow={selectStudentRow}
        districtStudentMatchAccessor={districtStudentMatchAccessor}
      />
      <SisMatchesActions
        selectedStudents={selectedStudents}
        onMatchSelectedStudents={onMatchSelectedStudents}
      />
    </React.Fragment>
  ) : (
    <></>
  )
}
